export default "__VITE_ASSET__D94zP5vP__"